import Header from "./components/Todo/Header";
import TodoList from "./views/TodoList";
import "./assets/css/index.css"
function App() {
  return (
    
    <div className="App">
      <TodoList />
    </div>
  );
}

export default App;
